import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';

export default class TheneSideOpenAccordion {

	constructor(dom) {

		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this.NAME = `TheneSideOpenAccordion`;

		this.dom = dom;

		this.buttonDoms = this.dom.querySelectorAll(`[data-theme-side-open-accordion-button]`);
		this.buttonDomActiveClass = `theme-side-open-accordion__button--active`;
		this.buttonDomInactiveClass = `theme-side-open-accordion__button--inactive`;

		this.drawerDomAttribute = `data-theme-side-open-accordion-drawer`;
		this.drawerDoms = this.dom.querySelectorAll(`[${this.drawerDomAttribute}]`);
		this.drawerDomActiveClass = `theme-side-open-accordion__drawer--active`;

		this.closeBtnDoms = this.dom.querySelectorAll('.theme-side-open-accordion__close-btn');
	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	init() {
		Logger.info(`${this.NAME} > init`);

		const self = this;

		if (this.buttonDoms.length) {
			this.openDrawer(this.buttonDoms[0]);
		}

		this.buttonDoms.forEach((buttonDom) => {
			buttonDom.addEventListener(`click`, (e) => {
				e.preventDefault();

				self.openDrawer(buttonDom);
			});
		});

		this.closeBtnDoms.forEach((btn) => {
			btn.addEventListener('click', () => {
				self.buttonDoms.forEach((subButtonDom) => {
					subButtonDom.classList.remove(self.buttonDomInactiveClass);
					subButtonDom.classList.remove(self.buttonDomActiveClass);
				})
				self.drawerDoms.forEach((drawer) => {
					drawer.classList.remove(self.drawerDomActiveClass);
				});
			})
		})
	}

	openDrawer(buttonDom) {
		this.buttonDoms.forEach((subButtonDom) => {
			if (subButtonDom == buttonDom) {
				subButtonDom.classList.add(this.buttonDomActiveClass);
				subButtonDom.classList.remove(this.buttonDomInactiveClass);
			} else {
				subButtonDom.classList.remove(this.buttonDomActiveClass);
				subButtonDom.classList.add(this.buttonDomInactiveClass);
			}
		});

		this.drawerDoms.forEach((drawer) => {
			drawer.classList.remove(this.drawerDomActiveClass);
		});

		const par = buttonDom.closest(`[data-theme-side-open-accordion-list-item]`);
		const drawerDom = par?.querySelector(`[${this.drawerDomAttribute}]`);
		drawerDom?.classList.add(this.drawerDomActiveClass);
	}

}

// Mixins
Object.assign(TheneSideOpenAccordion.prototype, eventMixin);
